import React from "react";
import IconBase from "./IconBase";

const RoundTick = props => {
    return (
        <IconBase {...props}>
            <path d="M12,2C6.5,2,2,6.5,2,12c0,5.5,4.5,10,10,10s10-4.5,10-10C22,6.5,17.5,2,12,2z M18.4,10l-7.2,7.2
	c-0.3,0.3-0.6,0.4-1,0.4s-0.7-0.1-1-0.4l-3.7-3.7c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1c0.6-0.6,1.5-0.6,2.1,0l2.6,2.6L16.3,8
	c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.5,0.7,0.5,1.1C18.8,9.4,18.7,9.7,18.4,10z"/>
        </IconBase>
    )
}

export default RoundTick;